import { render, staticRenderFns } from "./ImportDataset.vue?vue&type=template&id=6f6b89e4&scoped=true&"
import script from "./ImportDataset.vue?vue&type=script&lang=js&"
export * from "./ImportDataset.vue?vue&type=script&lang=js&"
import style0 from "./ImportDataset.vue?vue&type=style&index=0&id=6f6b89e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b89e4",
  null
  
)

export default component.exports